export default "__VITE_ASSET__BbTK4u3y__"